import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { NavArrowRight } from 'iconoir-react'
import { theme } from '../../Theme'
import { useIntl } from '@jetshop/intl'

const GoToPageWrapper = styled.div`
   margin-left: 0.25rem;
   display: flex;
   align-items: center;
   max-height: 33px;

   form {
      height: 100%;
      display: flex;
      align-items: stretch;
      flex-direction: row-reverse;
   }

   input {
      min-width: 115px;
      height: 100%;
      box-sizing: border-box;
      font-family: var(--font-industry) !important;
      padding: 0 0.5rem;
      border: 2px solid black;
      border-right: none;
      border-radius: 12px 0 0 12px;
      -moz-appearance: textfield;
      appearance: textfield;
      opacity: 0.5;
      font-weight: 500 !important;
      font-size: 1rem !important;
      ${theme.above.xl} {
         font-size: 1rem !important;
      }
   }

   #go-to-page-btn {
      height: 100%;
      box-sizing: border-box;
      font-family: var(--font-industry);
      border: 2px solid black;
      border-left: none;
      border-radius: 0 12px 12px 0;
      cursor: pointer;
      color: var(--color-white);
      background: var(--color-vb-blue);
      font-size: 1rem !important;
      font-weight: 500 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      ${theme.above.xl} {
         font-size: 1rem !important;
      }
      &:disabled {
         opacity: 0.5;
         cursor: default;
         pointer-events: none;
      }
   }
`

export default function GoToPage({ totalPages, handlePageChange }) {
   const t = useIntl()
   const [page, setPage] = useState('')

   const handleGoToPageSubmit = event => {
      event.preventDefault()
      let pageNumber = parseInt(page, 10)
      if (pageNumber < 1) {
         pageNumber = 1 // First page
      } else if (pageNumber > totalPages) {
         pageNumber = totalPages // Last page
      }
      handlePageChange(pageNumber)
      setPage('') // Reset the input field
   }

   return (
      <GoToPageWrapper>
         <form onSubmit={handleGoToPageSubmit}>
            <button
               id="go-to-page-btn"
               disabled={!page}
               type="submit"
            >
               <NavArrowRight strokeWidth={2.0} color="white" />
            </button>
            <input
               id="go-to-page"
               type="number"
               value={page}
               onChange={e => setPage(e.target.value)}
               placeholder={t('go-to-page')}
               min="1"
               max={totalPages}
            />
         </form>
      </GoToPageWrapper>
   )
}